/** Original, decorative mechanic illustrations. No vendor assets or remote requests. */
export function ActivityArt({ slug }: { slug: string }) {
  const mode = /race|climb|target/.test(slug) ? 'race' : /circuit|molarity|resist|hotspot/.test(slug) ? 'lab'
    : /sentence|reading/.test(slug) ? 'words' : /match|sort|flip/.test(slug) ? 'cards' : 'quiz';
  return <svg class={`activity-art art-${mode}`} viewBox="0 0 144 104" aria-hidden="true" focusable="false">
    <rect class="art-paper" x="0" y="0" width="144" height="104" rx="12" />
    {mode === 'cards' ? <g>
      {[0,1,2,3].map(i => <g key={i} transform={`translate(${24 + i%2*50},${16 + Math.floor(i/2)*38})`}>
        <rect class={i===1||i===2?'art-accent':'art-tile'} width="44" height="32" rx="5"/>
        <path class="art-line" d={i===1||i===2?'M17 15l4 4 7-8':'M16 10h12M16 16h8M16 22h12'}/>
      </g>)}
    </g> : mode === 'race' ? <g>
      <path class="art-line" d="M18 78h108M18 50h108M18 22h108"/>
      <rect class="art-accent" x="62" y="39" width="35" height="20" rx="6"/>
      <rect class="art-tile" x="30" y="67" width="35" height="20" rx="6"/>
      <circle class="art-ink" cx="71" cy="61" r="3"/><circle class="art-ink" cx="88" cy="61" r="3"/>
      <path class="art-line" d="M114 15v72M114 17h12v10h-12"/>
    </g> : mode === 'lab' ? <g>
      <path class="art-line" d="M38 20v22L22 77q-3 9 8 9h42q10 0 7-9L63 42V20M33 20h35"/>
      <path class="art-fill" d="M35 56h30l13 22q2 7-7 7H31q-9 0-6-7z"/>
      <circle class="art-tile" cx="108" cy="39" r="14"/>
      <path class="art-line" d="M108 24V15M123 39h10M94 39H84M108 54v10M101 39h14M108 32v14"/>
      <circle class="art-paper" cx="44" cy="65" r="3"/><circle class="art-paper" cx="57" cy="74" r="4"/>
    </g> : mode === 'words' ? <g>
      <rect class="art-tile" x="24" y="16" width="96" height="73" rx="6"/>
      <path class="art-line" d="M36 31h70M36 42h54M36 68h70M36 78h45"/>
      <rect class="art-accent" x="34" y="49" width="35" height="12" rx="3"/>
      <rect class="art-accent" x="75" y="49" width="32" height="12" rx="3"/>
    </g> : <g>
      <rect class="art-tile" x="23" y="17" width="98" height="72" rx="7"/>
      <path class="art-line" d="M37 31h68M37 40h41"/>
      <rect class="art-accent" x="35" y="53" width="34" height="24" rx="4"/>
      <rect class="art-paper" x="76" y="53" width="34" height="24" rx="4"/>
      <path class="art-line" d="M44 65l5 5 10-12M87 63h12M87 68h8"/>
    </g>}
  </svg>;
}
